import {useTranslation} from 'react-i18next';
import {ShieldCheck} from 'lucide-react';
import {FootNote, InfoBox, cn} from '@chekinapp/ui';

type Props = {
  variant?: 'box' | 'footnote';
  className?: string;
};

function PrivacyNote({variant = 'box', className}: Props) {
  const {t} = useTranslation();

  if (variant === 'footnote') {
    return (
      <FootNote
        size="sm"
        iconTone="success"
        icon={<ShieldCheck />}
        className={cn(
          'w-full font-medium [--foot-note-gap:8px] [--foot-note-icon-size:14px] [--foot-note-text:var(--chekin-text-secondary)]',
          className,
        )}
      >
        <strong className="font-semibold">{t('privacy_protected')}</strong>{' '}
        {t('privacy_protected_text')}
      </FootNote>
    );
  }

  return (
    <InfoBox className={className} icon={<ShieldCheck />}>
      <strong>{t('privacy_protected')}</strong> {t('privacy_protected_text')}
    </InfoBox>
  );
}

export {PrivacyNote};
